
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as authDl4WkJGltF74CwTAdGII86rc8sHUkrRHiQS_45LXubf4oMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/auth.vue?macro=true";
import { default as indexttPMNNoUlxew7vY__xXeGrz0lR_45SvY41h2OpTJr275MMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/index.vue?macro=true";
import { default as listsmWX91cK6mm0wBq_45j2wJLF_e_457OJwDzMP28gzCU4bdIMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/stock/list.vue?macro=true";
import { default as searchYg_4513kKfjW6hnZr5Ah1Nw3mviNGKQkH5rkV2O_IuRIkMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/note/search.vue?macro=true";
import { default as detailK1ogy9Crjy2Mr_45r2o0ZwpI11yhzdp79ru3pMubpxekEMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/stock/detail.vue?macro=true";
import { default as searchEPZ3UkXEOR9w4WfNQjQMqdJz0oPos_45JqXMdqAgSzl0oMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/stock/search.vue?macro=true";
import { default as indexJIjsMJ6JsIQSdiApjcmPHc_458XO1E_hRhKesTiZMucAAMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/multiLlm/index.vue?macro=true";
import { default as financialeUhmMGG1pJrPrS_45fH_NrRYGT4V76cObx658Bs0pbwQYMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/stock/financial.vue?macro=true";
import { default as historyMvIg9_gBD7hPxGJVErsZInV5_45LvCsf5svo5cP7F0yRwMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/multiLlm/history.vue?macro=true";
import { default as disclosurejcQ1LDeM5HCxKhq5HEac4NIwUKs0_45SDDp4LQllS5_zIMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/stock/disclosure.vue?macro=true";
import { default as file_SkkQak6s7fYIg6MhFS4LheCKlM_45jM20jGOEP23y_hcMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/survey/test/file.vue?macro=true";
import { default as htmlZbC0YSXUGbD9TZKGxN5quje91C_45hqKXGr27l9UqcoGcMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/survey/test/html.vue?macro=true";
import { default as textZxqELupexFEJA7wXUzvtjQuUOu49ouihn__45w60TFBQQMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/survey/test/text.vue?macro=true";
import { default as api_testYOl1T1S2b9X3xleMJUFQaO736vycOBdd62X3gSWZUY8Meta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/multiLlm/api_test.vue?macro=true";
import { default as tutorialnUqy4AejmtokE075_HJifVI7Q0wWXDPj0ngSRYhss_4Meta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/multiLlm/tutorial.vue?macro=true";
import { default as sourcePopup0HWJzwPmm_45EdECLoaCYV2InnvdX6X8c_lpb6yhU5m9cMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/stock/sourcePopup.vue?macro=true";
import { default as extraeuEkXHAD7mNicjGepbhYOPfvZXvm_45XN4jo5E_SaqbLoMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/survey/test/extra.vue?macro=true";
import { default as indexJzmjyvMFC0MLSHHVNasVKb035YbWGQhoEPFUUO08kJYMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/survey/test/index.vue?macro=true";
import { default as panelUL8Ls8Vwo_45vVzXGvvD5pkXbTzKtPyG6aeyq6pS0NlQIMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/survey/test/panel.vue?macro=true";
import { default as matrixkSGyAHe6o95sp73ZhVIyHEvtaEdizeBc9sPWiyyuxXwMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/survey/test/matrix.vue?macro=true";
import { default as ratingLOU39zdhn86rzAoLAHRSWAX0L5K0nvU09hmLZf3rVpUMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/survey/test/rating.vue?macro=true";
import { default as booleanrLxmkioMOsTKeXPnVNA0AR04ttBpilBYt1GRtU3xSrEMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/survey/test/boolean.vue?macro=true";
import { default as commentZZFaqP5BctAhNRAS9ayGZWIYW_451XW0ryp0HDXTHBvGcMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/survey/test/comment.vue?macro=true";
import { default as rankingGiIRf6OK7blOcC7GSQ9rJfDTBpc1zjpPqBnEePVgrzsMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/survey/test/ranking.vue?macro=true";
import { default as indexjzZGAKToTwT8gpBxOtHTScR4F6Uto_4_6WAbGNYAWuQMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/signin/index.vue?macro=true";
import { default as indexld_N_45Ym0d_45aZ6hMYaKA_45e28KqoymFSkXB2gMcnKcb7QMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/commerce/tdeal/index.vue?macro=true";
import { default as checkboxVgTE51o1lNDRHLQiJlNRgb4NtkvLigy0hiHSJ2M3aBIMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/survey/test/checkbox.vue?macro=true";
import { default as dropdownbBF7rEppwWZjsbQpgtzzWpNvs2eM2bSY2uN_45QfsuKmUMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/survey/test/dropdown.vue?macro=true";
import { default as example17DRyMmTYXvBjMdajMWII_ie67cfimUAiYVYiAJS5GHYMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/survey/test/example1.vue?macro=true";
import { default as index5BpDLXOhielhNNO1XHN4Hb52MnoMxgrdF_uZQmW4hesMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/privacy/index.vue?macro=true";
import { default as indexbLDqL7AR1WFKFzM_o3PLB39f6x1W2tZxSsJF9Py3_UwMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/profile/index.vue?macro=true";
import { default as indexJ2lr9aRYFv8uouC5uSvBcZUwZK2kloSbSGLZRKNt_rAMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/service/index.vue?macro=true";
import { default as expressionb_bAoa_VEdiHQhTMWtP5pWPJ5lka3sS5rMoAGyXJp3wMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/survey/test/expression.vue?macro=true";
import { default as radiogroupNhUcjKPCu6ZqKmOnIMrqzCh1PJcT8SyBwK2lcQL8WaYMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/survey/test/radiogroup.vue?macro=true";
import { default as imagepickerbkEgLXABLgntHrdD1JhBKT_pXfFGwzcq1RIQkTp1pGEMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/survey/test/imagepicker.vue?macro=true";
import { default as bridge_45to_45tdealL1QdZYJJUDEs0VzqNU_45m2eyMGfjingB_d6BFHb_McrMMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/commerce/bridge-to-tdeal.vue?macro=true";
import { default as multipletext_PMmZaDLFwBfVpvYmSm9_457u5mjoZo617WtYR8pK_45QtIMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/survey/test/multipletext.vue?macro=true";
import { default as paneldynamiczgNkEkMumBM5vyu63D7kNtYYIaGUZwD6G8A5HKFVQ9EMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/survey/test/paneldynamic.vue?macro=true";
import { default as signaturepadleBvWTU_S8AdzBGPHJAoOPRTMOq680CfJFmF95AsAvEMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/survey/test/signaturepad.vue?macro=true";
import { default as indexrPlzDZoJEZvPm7xQl1D_mM8oHWXMtpjgEHbBMC0kuT0Meta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/signup/auth/index.vue?macro=true";
import { default as indexawQ427sjuSUzK_450YYgScGfe6wtVFuQaax1uzRU_1Lo8Meta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/3rdParty/tphone/plan/index.vue?macro=true";
import { default as matrixdropdown5hG_iAFXMEIgKXahSJpF3P4R_GjJRlqMjioa5dXjumYMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/survey/test/matrixdropdown.vue?macro=true";
import { default as index1Is8ssT1RXri8HoSBvIMGgXTdSz9JecV5QqII1h5EecMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/3rdParty/auto/consent/index.vue?macro=true";
import { default as indexDIpRh5PETQ5JnnKR_AuhA9AnGeLqNXIOd__BNV8_456I4Meta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/3rdParty/musicservice/index.vue?macro=true";
import { default as socialLoginDBcRROVTis0FeN0DzzKLv0mIDknnCG_45NyT36Cnw5jQAMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/profile/socialLogin.vue?macro=true";
import { default as indexNsjlEcb3LF0pVxX_xvAPwhoXwdC3xemLhi3q3nm1jXUMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/terms/consent/index.vue?macro=true";
import { default as infoUgTdMvbGHY2qAAsOY9B_45uXvvkSbSQwpEF8jFn3DQHZkMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/terms/guardian/info.vue?macro=true";
import { default as indexx_45ND9OU1MHN0nAbf4WGoD58B_45hRpX0cv26Ukqrnwq_IMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/3rdParty/loginSdk/auth/index.vue?macro=true";
import { default as indexfRD2KJyhoUA_451Se3B0caL_C9f_3lQLXxuW6cl6G8d3IMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/privacy/policy/index.vue?macro=true";
import { default as chatZeREwD01OwGPLB_hRvIhdVukjWP5ibMF_cGsYjt0IjgMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/privacy/service/chat.vue?macro=true";
import { default as lifeIfMVT5BvlMIl4xfnluL8o_AMFBjVRFH5pKPu3C_45g8gUMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/privacy/service/life.vue?macro=true";
import { default as _91channelId_93hyCRJksfxTqxNkQOKWyjKfkm6y5p44_45f59aU8k38mFkMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/settings/[channelId].vue?macro=true";
import { default as errorLCM2WrGRitjZTJFes0bW7MHLzsb8QGo2kjdoAGYjg8EMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/web/account/withdrawal/error.vue?macro=true";
import { default as indexGLbWK66DMvvEvbM1y4QXiQUS_45C3B_45uAsGpWebdqLDKYMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/web/account/withdrawal/index.vue?macro=true";
import { default as briefiaL8zMILwwmMn1Ai4AHNzKyHUijJZqn8McPICzTrh6kMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/3rdParty/tphone/privacy/brief.vue?macro=true";
import { default as index4Y9pZ5V_YartTyIFTW9xjNg98aPzcmshEFYSHB7iChcMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/privacy/consent/index.vue?macro=true";
import { default as index2aNXOD9mawxa1ZPws0uAU7aidR_ZcbfIS0hEguCeOjgMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/privacy/profile/index.vue?macro=true";
import { default as brief7W4PnWEv0OhSpp4f2xvuplXFDOgcqIUEt5w5YYcj8rMMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/privacy/service/brief.vue?macro=true";
import { default as mediasWTgSkEuFzPGVvUU0FPs8WdvejfgHE6QnOLQPHSS6p8Meta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/privacy/service/media.vue?macro=true";
import { default as indexZ7_45AUJRsLNR_45VWwX8_45i1xKJ83gXX2go4BQJpi9LvRXIMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/terms/reconsent/index.vue?macro=true";
import { default as bridgeLzMtzQgrGkr4xFqqJVe00GVNYc3tB0MShUteSCxH2roMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/web/account/withdrawal/bridge.vue?macro=true";
import { default as signinzooazpM_45FX3Z8ZaayyScGHcfnSEb8CJffBtuO1ICASgMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/web/account/withdrawal/signin.vue?macro=true";
import { default as bridgeVM4a7R2_pCdyWanui8lotgAfTlfKeNkSDbnc90w0B2IMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/3rdParty/tphone/account/bridge.vue?macro=true";
import { default as ADCANOuDUuMkvZRgLAHzpcDk0uGUpe_45Y08dwlvLCGrQpMxlp4Meta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/privacy/service/ADCANO.vue?macro=true";
import { default as index4YaFjbRpKrj31o8M3bf7SlxW_45hdy9r2LtcIxPv_45p7moMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/settings/benefit/index.vue?macro=true";
import { default as indexX06GS5_459SUB_taRnfKWI2HJV0bl98_459IJ_TrmNGwWMcMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/settings/consent/index.vue?macro=true";
import { default as confirm6iCVki8Cdq1w_451tmtS7Ni7eBC5WET5cXm9wlAKhAbJUMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/terms/guardian/confirm.vue?macro=true";
import { default as successkUD5_HwM3SPTkRP4o_9_wxCrHCzgpqZdCwQ7F1F4T_458Meta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/web/account/withdrawal/success.vue?macro=true";
import { default as indexQsptG3655OAtB1mhuzO_45zFLf1yXFivrlyd5FWhGdEYUMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/3rdParty/loginSdk/consent/index.vue?macro=true";
import { default as indexQgo2Mg3MjTiLJavCtIBVLUUh2XKS2NPBfR5IiFSlql0Meta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/signin/suspension/index.vue?macro=true";
import { default as indexJOJQPQIkyKJyUBIGXkvYyjJKmXKESrZv6WL51M0bm84Meta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/profile/withdrawal/index.vue?macro=true";
import { default as _91channelId_93TQhUjhWaJM9x9zJbtK_skg34l6mUQUTqaiIlsHLVHKQMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/service/user/[channelId].vue?macro=true";
import { default as indexfLNUsSfA9c5NsQzqnz4YlQ99vQpRTAPHPZBT5dOrAUMMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/settings/voiceData/index.vue?macro=true";
import { default as indexVfDqWHsr548DKUCnO3ERm9x7HzxzU3kJo_4v66vRKL8Meta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/signin/connectIdps/index.vue?macro=true";
import { default as emailRegistrationeB3MM_LVg3_45PQQRHGXV2y06S4mHn0hBrm_XA_pjg2q0Meta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/profile/emailRegistration.vue?macro=true";
import { default as _91channelId_93uqIgdayv73jQxRvYexzW77XvNDy3z6fwaQga_45EjDNB4Meta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/service/tdeal/[channelId].vue?macro=true";
import { default as _91channelId_93ZMPa8SkxUkg0bobFxTe2LhCns9OsGHxRJGYSd870zqAMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/terms/consent/[channelId].vue?macro=true";
import { default as bridge_45to_45external_45tdealFxVPBGiMly7YBdMRutUb746YYeEQ7kKBaeDhISXqS2oMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/commerce/bridge-to-external-tdeal.vue?macro=true";
import { default as index2xBRSJGr6flz5oFUOrlceq5wZ8WvuhJNS9FlymZabiwMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/3rdParty/loginSdk/suspension/index.vue?macro=true";
import { default as detail0bUPVp3skhY5yHYDMlZaeYGgyHOyvBYE2dzPcsYmCu0Meta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/3rdParty/tphone/callSummary/detail.vue?macro=true";
import { default as _91briefingContentsId_938KzUPYC5rRFKgiZ8aUn97QONZ_J9fPHbfAQ6wSjdDhAMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/briefing/view/[briefingContentsId].vue?macro=true";
import { default as history32KAdwoUWxdXUFedcKj5DgDMEg05tBRW7MYldesgk60Meta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/3rdParty/tphone/callSummary/history.vue?macro=true";
import { default as indexUXAKlg02o9Xr1EMEt1qe3FXD_45HiCeKpH_45D6BxRVnRu8Meta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/signin/duplicatedIdps/index.vue?macro=true";
import { default as subscriptionErroregfqUqGULfoUqXQl5L3oGXIr560Rs3d6kymlSD2xEc8Meta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/3rdParty/tphone/plan/subscriptionError.vue?macro=true";
import { default as privacySummaryMKdQQ0T1Dau5_45O78np2zLhzKh_qpldIG9WPS6hITt_kMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/privacy/service/privacySummary.vue?macro=true";
import { default as indexlTiMdq5d6OiutDl7m4YfK1Yizsin3WAARSeZlMSfx5MMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/3rdParty/tphone/bizContact/detail/index.vue?macro=true";
import { default as indexfPfb1dajhlt5b6KzFNX1Viiecn8KTRTr93Kis8qwH70Meta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/signup/auth/guardian/agree/index.vue?macro=true";
import { default as subscriptionConfirmed5Vgq4WCQ36_6VRRri_45dO_45Uzar08A3TBWK7RWnLEAZr0Meta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/3rdParty/tphone/plan/subscriptionConfirmed.vue?macro=true";
import { default as checkSmsuyk8Faeu4NGpd9_znnxRJWgLiVxCKCpcgEay_45mdeK5IMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/signup/auth/guardian/agree/checkSms.vue?macro=true";
import { default as indexLef44XcPKm5mRrh7l8SWeb6w6MGxCjFFjA0Oi4Vj4GQMeta } from "/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/3rdParty/tphone/bizContact/weeklyDetail/index.vue?macro=true";
export default [
  {
    name: "auth",
    path: "/auth",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/auth.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/index.vue")
  },
  {
    name: "stock-list",
    path: "/stock/list",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/stock/list.vue")
  },
  {
    name: "note-search",
    path: "/note/search",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/note/search.vue")
  },
  {
    name: "stock-detail",
    path: "/stock/detail",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/stock/detail.vue")
  },
  {
    name: "stock-search",
    path: "/stock/search",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/stock/search.vue")
  },
  {
    name: "multiLlm",
    path: "/multiLlm",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/multiLlm/index.vue")
  },
  {
    name: "stock-financial",
    path: "/stock/financial",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/stock/financial.vue")
  },
  {
    name: "multiLlm-history",
    path: "/multiLlm/history",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/multiLlm/history.vue")
  },
  {
    name: "stock-disclosure",
    path: "/stock/disclosure",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/stock/disclosure.vue")
  },
  {
    name: "survey-test-file",
    path: "/survey/test/file",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/survey/test/file.vue")
  },
  {
    name: "survey-test-html",
    path: "/survey/test/html",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/survey/test/html.vue")
  },
  {
    name: "survey-test-text",
    path: "/survey/test/text",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/survey/test/text.vue")
  },
  {
    name: "multiLlm-api_test",
    path: "/multiLlm/api_test",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/multiLlm/api_test.vue")
  },
  {
    name: "multiLlm-tutorial",
    path: "/multiLlm/tutorial",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/multiLlm/tutorial.vue")
  },
  {
    name: "stock-sourcePopup",
    path: "/stock/sourcePopup",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/stock/sourcePopup.vue")
  },
  {
    name: "survey-test-extra",
    path: "/survey/test/extra",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/survey/test/extra.vue")
  },
  {
    name: "survey-test",
    path: "/survey/test",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/survey/test/index.vue")
  },
  {
    name: "survey-test-panel",
    path: "/survey/test/panel",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/survey/test/panel.vue")
  },
  {
    name: "survey-test-matrix",
    path: "/survey/test/matrix",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/survey/test/matrix.vue")
  },
  {
    name: "survey-test-rating",
    path: "/survey/test/rating",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/survey/test/rating.vue")
  },
  {
    name: "survey-test-boolean",
    path: "/survey/test/boolean",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/survey/test/boolean.vue")
  },
  {
    name: "survey-test-comment",
    path: "/survey/test/comment",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/survey/test/comment.vue")
  },
  {
    name: "survey-test-ranking",
    path: "/survey/test/ranking",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/survey/test/ranking.vue")
  },
  {
    name: "account-signin",
    path: "/account/signin",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/signin/index.vue")
  },
  {
    name: "commerce-tdeal",
    path: "/commerce/tdeal",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/commerce/tdeal/index.vue")
  },
  {
    name: "survey-test-checkbox",
    path: "/survey/test/checkbox",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/survey/test/checkbox.vue")
  },
  {
    name: "survey-test-dropdown",
    path: "/survey/test/dropdown",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/survey/test/dropdown.vue")
  },
  {
    name: "survey-test-example1",
    path: "/survey/test/example1",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/survey/test/example1.vue")
  },
  {
    name: "account-privacy",
    path: "/account/privacy",
    meta: index5BpDLXOhielhNNO1XHN4Hb52MnoMxgrdF_uZQmW4hesMeta || {},
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/privacy/index.vue")
  },
  {
    name: "account-profile",
    path: "/account/profile",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/profile/index.vue")
  },
  {
    name: "account-service",
    path: "/account/service",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/service/index.vue")
  },
  {
    name: "survey-test-expression",
    path: "/survey/test/expression",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/survey/test/expression.vue")
  },
  {
    name: "survey-test-radiogroup",
    path: "/survey/test/radiogroup",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/survey/test/radiogroup.vue")
  },
  {
    name: "survey-test-imagepicker",
    path: "/survey/test/imagepicker",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/survey/test/imagepicker.vue")
  },
  {
    name: "commerce-bridge-to-tdeal",
    path: "/commerce/bridge-to-tdeal",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/commerce/bridge-to-tdeal.vue")
  },
  {
    name: "survey-test-multipletext",
    path: "/survey/test/multipletext",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/survey/test/multipletext.vue")
  },
  {
    name: "survey-test-paneldynamic",
    path: "/survey/test/paneldynamic",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/survey/test/paneldynamic.vue")
  },
  {
    name: "survey-test-signaturepad",
    path: "/survey/test/signaturepad",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/survey/test/signaturepad.vue")
  },
  {
    name: "account-signup-auth",
    path: "/account/signup/auth",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/signup/auth/index.vue")
  },
  {
    name: "3rdParty-tphone-plan",
    path: "/3rdParty/tphone/plan",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/3rdParty/tphone/plan/index.vue")
  },
  {
    name: "survey-test-matrixdropdown",
    path: "/survey/test/matrixdropdown",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/survey/test/matrixdropdown.vue")
  },
  {
    name: "3rdParty-auto-consent",
    path: "/3rdParty/auto/consent",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/3rdParty/auto/consent/index.vue")
  },
  {
    name: "3rdParty-musicservice",
    path: "/3rdParty/musicservice",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/3rdParty/musicservice/index.vue")
  },
  {
    name: "account-profile-socialLogin",
    path: "/account/profile/socialLogin",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/profile/socialLogin.vue")
  },
  {
    name: "account-terms-consent",
    path: "/account/terms/consent",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/terms/consent/index.vue")
  },
  {
    name: "account-terms-guardian-info",
    path: "/account/terms/guardian/info",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/terms/guardian/info.vue")
  },
  {
    name: "3rdParty-loginSdk-auth",
    path: "/3rdParty/loginSdk/auth",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/3rdParty/loginSdk/auth/index.vue")
  },
  {
    name: "account-privacy-policy",
    path: "/account/privacy/policy",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/privacy/policy/index.vue")
  },
  {
    name: "account-privacy-service-chat",
    path: "/account/privacy/service/chat",
    meta: chatZeREwD01OwGPLB_hRvIhdVukjWP5ibMF_cGsYjt0IjgMeta || {},
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/privacy/service/chat.vue")
  },
  {
    name: "account-privacy-service-life",
    path: "/account/privacy/service/life",
    meta: lifeIfMVT5BvlMIl4xfnluL8o_AMFBjVRFH5pKPu3C_45g8gUMeta || {},
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/privacy/service/life.vue")
  },
  {
    name: "account-settings-channelId",
    path: "/account/settings/:channelId()",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/settings/[channelId].vue")
  },
  {
    name: "web-account-withdrawal-error",
    path: "/web/account/withdrawal/error",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/web/account/withdrawal/error.vue")
  },
  {
    name: "web-account-withdrawal",
    path: "/web/account/withdrawal",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/web/account/withdrawal/index.vue")
  },
  {
    name: "3rdParty-tphone-privacy-brief",
    path: "/3rdParty/tphone/privacy/brief",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/3rdParty/tphone/privacy/brief.vue")
  },
  {
    name: "account-privacy-consent",
    path: "/account/privacy/consent",
    meta: index4Y9pZ5V_YartTyIFTW9xjNg98aPzcmshEFYSHB7iChcMeta || {},
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/privacy/consent/index.vue")
  },
  {
    name: "account-privacy-profile",
    path: "/account/privacy/profile",
    meta: index2aNXOD9mawxa1ZPws0uAU7aidR_ZcbfIS0hEguCeOjgMeta || {},
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/privacy/profile/index.vue")
  },
  {
    name: "account-privacy-service-brief",
    path: "/account/privacy/service/brief",
    meta: brief7W4PnWEv0OhSpp4f2xvuplXFDOgcqIUEt5w5YYcj8rMMeta || {},
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/privacy/service/brief.vue")
  },
  {
    name: "account-privacy-service-media",
    path: "/account/privacy/service/media",
    meta: mediasWTgSkEuFzPGVvUU0FPs8WdvejfgHE6QnOLQPHSS6p8Meta || {},
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/privacy/service/media.vue")
  },
  {
    name: "account-terms-reconsent",
    path: "/account/terms/reconsent",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/terms/reconsent/index.vue")
  },
  {
    name: "web-account-withdrawal-bridge",
    path: "/web/account/withdrawal/bridge",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/web/account/withdrawal/bridge.vue")
  },
  {
    name: "web-account-withdrawal-signin",
    path: "/web/account/withdrawal/signin",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/web/account/withdrawal/signin.vue")
  },
  {
    name: "3rdParty-tphone-account-bridge",
    path: "/3rdParty/tphone/account/bridge",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/3rdParty/tphone/account/bridge.vue")
  },
  {
    name: "account-privacy-service-ADCANO",
    path: "/account/privacy/service/ADCANO",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/privacy/service/ADCANO.vue")
  },
  {
    name: "account-settings-benefit",
    path: "/account/settings/benefit",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/settings/benefit/index.vue")
  },
  {
    name: "account-settings-consent",
    path: "/account/settings/consent",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/settings/consent/index.vue")
  },
  {
    name: "account-terms-guardian-confirm",
    path: "/account/terms/guardian/confirm",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/terms/guardian/confirm.vue")
  },
  {
    name: "web-account-withdrawal-success",
    path: "/web/account/withdrawal/success",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/web/account/withdrawal/success.vue")
  },
  {
    name: "3rdParty-loginSdk-consent",
    path: "/3rdParty/loginSdk/consent",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/3rdParty/loginSdk/consent/index.vue")
  },
  {
    name: "account-signin-suspension",
    path: "/account/signin/suspension",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/signin/suspension/index.vue")
  },
  {
    name: "account-profile-withdrawal",
    path: "/account/profile/withdrawal",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/profile/withdrawal/index.vue")
  },
  {
    name: "account-service-user-channelId",
    path: "/account/service/user/:channelId()",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/service/user/[channelId].vue")
  },
  {
    name: "account-settings-voiceData",
    path: "/account/settings/voiceData",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/settings/voiceData/index.vue")
  },
  {
    name: "account-signin-connectIdps",
    path: "/account/signin/connectIdps",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/signin/connectIdps/index.vue")
  },
  {
    name: "account-profile-emailRegistration",
    path: "/account/profile/emailRegistration",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/profile/emailRegistration.vue")
  },
  {
    name: "account-service-tdeal-channelId",
    path: "/account/service/tdeal/:channelId()",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/service/tdeal/[channelId].vue")
  },
  {
    name: "account-terms-consent-channelId",
    path: "/account/terms/consent/:channelId()",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/terms/consent/[channelId].vue")
  },
  {
    name: "commerce-bridge-to-external-tdeal",
    path: "/commerce/bridge-to-external-tdeal",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/commerce/bridge-to-external-tdeal.vue")
  },
  {
    name: "3rdParty-loginSdk-suspension",
    path: "/3rdParty/loginSdk/suspension",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/3rdParty/loginSdk/suspension/index.vue")
  },
  {
    name: "3rdParty-tphone-callSummary-detail",
    path: "/3rdParty/tphone/callSummary/detail",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/3rdParty/tphone/callSummary/detail.vue")
  },
  {
    name: "briefing-view-briefingContentsId",
    path: "/briefing/view/:briefingContentsId()",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/briefing/view/[briefingContentsId].vue")
  },
  {
    name: "3rdParty-tphone-callSummary-history",
    path: "/3rdParty/tphone/callSummary/history",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/3rdParty/tphone/callSummary/history.vue")
  },
  {
    name: "account-signin-duplicatedIdps",
    path: "/account/signin/duplicatedIdps",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/signin/duplicatedIdps/index.vue")
  },
  {
    name: "3rdParty-tphone-plan-subscriptionError",
    path: "/3rdParty/tphone/plan/subscriptionError",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/3rdParty/tphone/plan/subscriptionError.vue")
  },
  {
    name: "account-privacy-service-privacySummary",
    path: "/account/privacy/service/privacySummary",
    meta: privacySummaryMKdQQ0T1Dau5_45O78np2zLhzKh_qpldIG9WPS6hITt_kMeta || {},
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/privacy/service/privacySummary.vue")
  },
  {
    name: "3rdParty-tphone-bizContact-detail",
    path: "/3rdParty/tphone/bizContact/detail",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/3rdParty/tphone/bizContact/detail/index.vue")
  },
  {
    name: "account-signup-auth-guardian-agree",
    path: "/account/signup/auth/guardian/agree",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/signup/auth/guardian/agree/index.vue")
  },
  {
    name: "3rdParty-tphone-plan-subscriptionConfirmed",
    path: "/3rdParty/tphone/plan/subscriptionConfirmed",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/3rdParty/tphone/plan/subscriptionConfirmed.vue")
  },
  {
    name: "account-signup-auth-guardian-agree-checkSms",
    path: "/account/signup/auth/guardian/agree/checkSms",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/account/signup/auth/guardian/agree/checkSms.vue")
  },
  {
    name: "3rdParty-tphone-bizContact-weeklyDetail",
    path: "/3rdParty/tphone/bizContact/weeklyDetail",
    component: () => import("/var/lib/jenkins/workspace/adot-webview-prd-deploy/pages/3rdParty/tphone/bizContact/weeklyDetail/index.vue")
  }
]